import React from "react";
import { useNavigate } from "react-router-dom";

const PostCard = (props) => {
  const navigate = useNavigate();

  const goToPost = () => {
    navigate(`/post/${props.postId}`);
  };

  return (
    <div
      className="card postcardbody shadow-sm"
      onClick={goToPost}
      style={{ cursor: "pointer" }}
    >
      <div className="card-body">
        <h5 className="card-title">{props.postTitle}</h5>
        <p className="card-text">{props.userName}</p>
      </div>
    </div>
  );
};

export default PostCard;
